<template>
  <div class="modal" :class="{ 'is-active': opened }">
    <div class="modal-background" @click="goHome"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t("create-room.create-room") }}
        </p>
        <button class="delete" @click="goHome"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">{{ $t("create-room.name") }}</label>
          <div class="control">
            <input type="text" class="input" v-model="roomName" />
          </div>
          <p v-if="showError" class="help is-danger">
            {{ this.error }}
          </p>
        </div>
        <div class="field">
          <label class="label">{{ $t("create-room.description") }}</label>
          <div class="control">
            <textarea class="textarea" v-model="description"></textarea>
          </div>
        </div>
        <!-- <div class="field">
                    <label class="label">{{ $t("create-room.users") }}</label>
                    <div class="control">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <input
                                    type="text"
                                    class="input"
                                    v-model="userEmail"
                                    @keypress.enter="addUser"
                                />
                            </div>
                            <div class="control">
                                <button
                                    class="button is-primary"
                                    :disabled="emailIsEmpty"
                                    @click="addUser"
                                >
                                    <Icon family="fa" name="fa-plus" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <div
                                class="columns mt-1"
                                v-for="user in users"
                                :key="user.email"
                            >
                                <div class="column is-1">
                                    <Icon name="fa-circle" />
                                </div>
                                <div class="column">
                                    {{ user.email }}
                                </div>
                                <div class="column is-narrow">
                                    <button
                                        class="button is-small"
                                        @click="removeUser(user.email)"
                                    >
                                        <Icon name="fa-trash-alt" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
      </section>
      <footer class="modal-card-foot flex-end">
        <button
          class="button is-success"
          :class="{ 'is-loading': isLoading }"
          @click="createRoom"
          :disabled="disabledCreate"
        >
          {{ $t("create-room.create") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";

export default {
  name: "create-room-modal",
  props: {
    display: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roomId: "",
      opened: false,

      roomName: "",
      description: "",
      users: [],
      userEmail: "",
      isLoading: false,
      error: "",
    };
  },
  mounted() {
    this.opened = this.display;
  },
  watch: {
    display(opened) {
      this.opened = opened;
    },
  },
  computed: {
    disabledCreate() {
      return this.roomName === "";
    },
    emailIsEmpty() {
      return this.userEmail === "";
    },
    showError() {
      return this.error !== "";
    },
  },
  methods: {
    async createRoom() {
      this.isLoading = true;
      this.error = "";
      try {
        let response = await RepositoryFactory.conference.create({
          name: this.roomName,
          description: this.description,
        });
        var roomId = response.data;
        this.$router.push({
          name: "room",
          params: { roomId: roomId },
        });
      } catch (error) {
        window.console.log(error);
        this.error = "Error generating the conference";
      }
      this.isLoading = false;
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    addUser() {
      this.users.push({ email: this.userEmail });
      this.userEmail = "";
    },
    removeUser(email) {
      this.users = this.users.filter((u) => u.email !== email);
    },
  },
};
</script>
